// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"721":"f47cf056","787":"c6374781"}[chunkId] + ".chunk.js";
};